import { isOperationalIntelligenceMode } from '../operationalIntelligence/operationalIntelligenceFlags';

export function isOperationalCoordinationMode(): boolean {
  const v = process.env.REACT_APP_OPERATIONAL_COORDINATION;
  if (v === 'false') return false;
  return v === 'true' || isOperationalIntelligenceMode();
}
